import { View } from "../enums/View";

export const getDefaultView = (): View | null => (window.matchMedia("(max-width: 620px)").matches ? null : View.Profile);
